import { render, staticRenderFns } from "./InsideDetail.vue?vue&type=template&id=1ab91748&scoped=true"
import script from "./InsideDetail.vue?vue&type=script&lang=js"
export * from "./InsideDetail.vue?vue&type=script&lang=js"
import style0 from "./InsideDetail.vue?vue&type=style&index=0&id=1ab91748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab91748",
  null
  
)

export default component.exports